export const iconLogoPath = '/images/teacher-logo.png';